import { Shield, Clock, Smartphone, QrCode, Globe, Heart } from "lucide-react";

const features = [
  {
    icon: QrCode,
    title: "QR Code Technology",
    description: "Advanced QR technology that instantly connects finders to owners through secure digital identity."
  },
  {
    icon: Shield,
    title: "Privacy Protected",
    description: "Your personal information stays secure while enabling seamless communication between finder and owner."
  },
  {
    icon: Clock,
    title: "Instant Connection",
    description: "No delays or complicated processes - just scan and connect immediately with the item's owner."
  },
  {
    icon: Smartphone,
    title: "Mobile Optimized",
    description: "Works perfectly on any smartphone without requiring app downloads or account creation."
  },
  {
    icon: Globe,
    title: "Universal Access",
    description: "Accessible worldwide with multi-language support for global item recovery solutions."
  },
  {
    icon: Heart,
    title: "Community Driven",
    description: "Built by people who care about reuniting lost items with their owners through technology."
  }
];

export function AboutFeaturesSection() {
  // Generate Product Schema for SEO
  const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Metefy Digital Identity Platform",
    "description": "Advanced QR code technology platform for item recovery and digital identity management with privacy-first approach",
    "brand": {
      "@type": "Brand",
      "name": "Metefy"
    },
    "category": "Software Application",
    "url": "https://metefy.com",
    "features": features.map(feature => feature.title),
    "additionalProperty": features.map(feature => ({
      "@type": "PropertyValue",
      "name": feature.title,
      "value": feature.description
    })),
    "offers": {
      "@type": "Offer",
      "price": "179",
      "priceCurrency": "INR",
      "availability": "https://schema.org/InStock",
      "url": "https://metefy.in",
      "priceValidUntil": "2026-12-31"
    }
  };

  return (
    <section id="features" className="py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 border border-primary/20 rounded-lg text-foreground font-semibold text-sm mb-6">
            <Shield className="w-4 h-4 text-foreground" />
            <span className="text-foreground">Features</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-6">
            Why Choose <span className="text-primary">Metefy</span>?
          </h2>
          <p className="text-xl text-foreground/80 max-w-3xl mx-auto">
            Discover the powerful features that make Metefy the most trusted platform for digital identity and item recovery
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="group bg-card p-8 rounded-2xl border-2 border-border hover:border-primary transition-all duration-300 hover:shadow-lg">
              <div className="flex items-center gap-3 mb-4">
                <div className="bg-primary/10 rounded-lg p-2 group-hover:bg-primary/20 transition-all duration-300">
                  <feature.icon className="w-5 h-5 text-primary" />
                </div>
                <h3 className="text-xl font-bold text-foreground">
                  {feature.title}
                </h3>
              </div>
              <p className="text-foreground/80 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Inject Product Schema for SEO - hidden from users */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(productSchema) }}
        aria-hidden="true"
      ></script>
    </section>
  );
} 